import React from "react";
import { useParams } from 'react-router-dom';
import AllTeams from "./AllTeams";
import SingleTeam from "./SingleTeam";

const TeamsSummary = (props) => {

    const { team_id } = useParams();

    return (
        <div className="mt-4">
           
            { team_id &&
                <SingleTeam allMembers={props?.members} owner={props?.owner} />
            }

            { !team_id &&
                <AllTeams teams={props?.teams} />
            }

        </div>
    )

}

export default TeamsSummary;